var render, staticRenderFns
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"
import style0 from "./Question.vue?vue&type=style&index=0&id=07578fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07578fc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vincent/webroot/www.circulusberkel.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07578fc4')) {
      api.createRecord('07578fc4', component.options)
    } else {
      api.reload('07578fc4', component.options)
    }
    
  }
}
component.options.__file = "vue-apps/faq/Components/Question.vue"
export default component.exports